import React from "react";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBIcon,
  MDBRow,
  MDBCol,
  MDBInput,
} from "mdb-react-ui-kit";

import { doFetchJson } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";

/**
 * SesionFormModal — crear o editar una sesión (RepresentacionFecha).
 *
 * Props:
 *  - show: boolean
 *  - sesion: RepresentacionFechaDTO (null si es nueva sesión)
 *  - idRepresentacion: número — obligatorio para crear (null si editar)
 *  - funcionName: string — para mostrar en el título
 *  - onClose: () => void
 *  - onSaved: (sesion) => void
 */
class SesionFormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState(props.sesion);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      this.setState(this.initialState(this.props.sesion));
    }
  }

  initialState = (sesion) => {
    if (sesion && sesion.idRepresentacionFecha) {
      return {
        isEdit: true,
        startDatetime: sesion.startDatetime
          ? sesion.startDatetime.slice(0, 16)
          : "",
        endDatetime: sesion.endDatetime
          ? sesion.endDatetime.slice(0, 16)
          : "",
        saving: false,
      };
    }
    return {
      isEdit: false,
      startDatetime: "",
      endDatetime: "",
      saving: false,
    };
  };

  handleClose = () => {
    if (this.state.saving) return;
    if (this.props.onClose) this.props.onClose();
  };

  handleChange = (field) => (e) => {
    this.setState({ [field]: e.target.value });
  };

  validate = () => {
    const { startDatetime } = this.state;
    if (!startDatetime) {
      toast.show({ message: "La fecha y hora de inicio es obligatoria", type: "warning" });
      return false;
    }
    return true;
  };

  handleSave = () => {
    if (!this.validate()) return;
    const { sesion, idRepresentacion } = this.props;
    const { isEdit, startDatetime, endDatetime } = this.state;

    const body = {
      startDatetime: startDatetime ? startDatetime + ":00" : null,
      endDatetime: endDatetime ? endDatetime + ":00" : null,
    };
    if (isEdit && sesion) {
      body.idRepresentacionFecha = sesion.idRepresentacionFecha;
    }

    const url =
      "upsertSesion" +
      (!isEdit ? "?idRepresentacion=" + encodeURIComponent(idRepresentacion) : "");

    this.setState({ saving: true });
    doFetchJson("TEAN", url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((json) => {
        if (json && json.STATE === "SUCCESS") {
          toast.show({
            message: isEdit ? "Sesión actualizada" : "Sesión añadida",
            type: "success",
          });
          if (this.props.onSaved) this.props.onSaved(json.DATA);
          if (this.props.onClose) this.props.onClose();
        } else {
          toast.show({
            message: (json && json.MESSAGE) || "Error al guardar la sesión",
            type: "danger",
          });
        }
      })
      .catch(() => {
        toast.show({ message: "Error de conexión al guardar la sesión", type: "danger" });
      })
      .finally(() => this.setState({ saving: false }));
  };

  render() {
    const { show, funcionName } = this.props;
    const { isEdit, startDatetime, endDatetime, saving } = this.state;

    return (
      <MDBModal show={show} onHide={this.handleClose} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <MDBIcon far icon="clock" className="me-2" />
                {isEdit ? "Editar sesión" : "Nueva sesión"}
                {funcionName && (
                  <span className="text-muted fw-normal small ms-2">— {funcionName}</span>
                )}
              </MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={this.handleClose} />
            </MDBModalHeader>

            <MDBModalBody>
              <MDBRow className="g-3">
                <MDBCol size="12" md="6">
                  <MDBInput
                    type="datetime-local"
                    label="Inicio *"
                    value={startDatetime}
                    onChange={this.handleChange("startDatetime")}
                    disabled={saving}
                  />
                </MDBCol>
                <MDBCol size="12" md="6">
                  <MDBInput
                    type="datetime-local"
                    label="Fin (opcional)"
                    value={endDatetime}
                    onChange={this.handleChange("endDatetime")}
                    disabled={saving}
                  />
                </MDBCol>
              </MDBRow>
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={this.handleClose} disabled={saving}>
                Cancelar
              </MDBBtn>
              <MDBBtn color="primary" onClick={this.handleSave} disabled={saving}>
                {saving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1" />
                    Guardando...
                  </>
                ) : (
                  <>
                    <MDBIcon fas icon="save" className="me-1" />
                    {isEdit ? "Guardar cambios" : "Añadir sesión"}
                  </>
                )}
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    );
  }
}

export default SesionFormModal;
